export default __webpack_public_path__ + "img/14.8cf7a253.jpg";